import { Country } from 'country-list';
import {
    RiskEvaluationColor,
    RiskEvaluationModelItemInput,
    RiskEvaluationScoreTrendType,
} from 'types/graphql-global-types';
import {
    CompleteRiskFields,
    CompleteRiskFields_Risk_controls_StudyControl as CompleteRiskFields_controls,
    CompleteRiskFields_Risk_evaluationHistory_RiskEvaluation as CompleteRiskFields_evaluationHistory,
} from '@queries/generated/fragments.generated';
import {
    riskObservations_OpraQueries_riskObservations_RiskObservation_actions_RiskAction,
    riskObservationsRisks_OpraQueries_riskObservations_RiskObservation,
} from '@queries/generated/legacy-risk-assessment.generated';

export enum RiskLogChipsValues {
    Attributes = 1,
    Evaluation = 2,
    CtQs = 3,
    Controls = 4,
    Monitoring = 5,
    CmControls = 6,
}

export type EvaluationModel = {
    key: string;
    label: string;
    tooltip: string;
    evaluationsOptions: (RiskEvaluationModelItemInput | null)[];
};

export interface ExtendedRiskObservationFields extends Omit<
    riskObservationsRisks_OpraQueries_riskObservations_RiskObservation,
    'createdBy' | 'updatedBy'
> {
    createdBy: string;
    updatedBy: string;
    recentActionDate?: string | undefined;
    numActions?: number;
    numOpenActions?: number;
    reasonForDeletion?: string | null | undefined;
    deletedDate?: string;
    deletedBy?: string | undefined;
}

export interface ExtendedCompleteRiskFields extends Omit<CompleteRiskFields, 'createdBy' | 'updatedBy' | 'countries'> {
    createdBy: string;
    updatedBy: string;
    numActiveCtQs: number;
    numOpenObservations: number;
    numDeletedObservations?: number;
    numOpenActions: number;
    numLinkedCMControls?: number;
    countryList: string | null;
    vendorList: string | null;
    reviewFrequency: string | null;
    convertedOwner: { name: string; active: boolean } | null;
    canBeDeleted: boolean;
    countries: Country[] | null;
}

export interface ExtendedRiskActionFields extends Omit<
    riskObservations_OpraQueries_riskObservations_RiskObservation_actions_RiskAction,
    'createdBy' | 'updatedBy' | 'owner' | 'type'
> {
    createdBy: string;
    updatedBy: string;
    owner: {
        name: string;
        active: boolean | null;
        email: string | null;
    };
    riskId: string | null;
    riskStatement: string | null;
    reasonForDeletion?: string | null | undefined;
    deletedDate?: string;
    deletedBy?: string | undefined;
    type: string | undefined;
    observationId: string;
    observation: ExtendedRiskObservationFields | undefined;
    riskRecordId: string | null;
}

export interface ExtendedCompleteRiskFieldsEvaluationHistory extends Omit<
    CompleteRiskFields_evaluationHistory,
    'createdBy' | 'updatedBy' | 'score'
> {
    createdBy: string;
    updatedBy: string;
    score: {
        score: number;
        colour: RiskEvaluationColor | null;
        movement: string | RiskEvaluationScoreTrendType | null;
        sortMovement: number;
        prevScore: number | null;
        prevColour: RiskEvaluationColor | null;
    };
    evaluationModelName?: string | null;
}

export interface ExtendedCompleteRiskFieldsControl extends Omit<
    CompleteRiskFields_controls,
    'createdBy' | 'updatedBy'
> {
    createdBy: string;
    updatedBy: string;
    convertedOwner: { name: string; active: boolean | null };
    reviewFrequency: string | null;
    riskRecordId: string | null;
    riskStatement: string | null;
}
